// Google Material Symbols Rounded / 400 / GRAD 0. Apache-2.0.
// Pinned to bd8cb85bd4bad964fe6918f79665bb40c3a8efef.
import { MaterialSymbol, type MaterialIconProps } from './material-symbol';
const artwork = {
  "outline20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M444-330v-402.02q0-15.29 10.29-25.64Q464.58-768 479.79-768t25.71 10.34q10.5 10.35 10.5 25.64V-330l176.21-176.21Q703-517 717.5-517t25.98 11Q754-495 754-480.5t-10.82 25.31L505.09-217.4q-5.41 5.4-11.72 7.9-6.31 2.5-13.53 2.5-7.21 0-13.53-2.5Q460-212 455-217L217-455q-11-11-10.5-25.5t11.02-25.5q11.48-11 26.15-11 14.66 0 25.33 11l175 176Z"
    ]
  },
  "outline24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M440-313v-447q0-17 11.5-28.5T480-800q17 0 28.5 11.5T520-760v447l196-196q12-12 28-11.5t28 12.5q11 12 11.5 28T772-452L508-188q-6 6-13 8.5t-15 2.5q-8 0-15-2.5t-13-8.5L188-452q-11-11-11-27.5t11-28.5q12-12 28.5-12t28.5 12l195 195Z"
    ]
  },
  "filled20": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M444-330v-402.02q0-15.29 10.29-25.64Q464.58-768 479.79-768t25.71 10.34q10.5 10.35 10.5 25.64V-330l176.21-176.21Q703-517 717.5-517t25.98 11Q754-495 754-480.5t-10.82 25.31L505.09-217.4q-5.41 5.4-11.72 7.9-6.31 2.5-13.53 2.5-7.21 0-13.53-2.5Q460-212 455-217L217-455q-11-11-10.5-25.5t11.02-25.5q11.48-11 26.15-11 14.66 0 25.33 11l175 176Z"
    ]
  },
  "filled24": {
    "viewBox": "0 -960 960 960",
    "paths": [
      "M440-313v-447q0-17 11.5-28.5T480-800q17 0 28.5 11.5T520-760v447l196-196q12-12 28-11.5t28 12.5q11 12 11.5 28T772-452L508-188q-6 6-13 8.5t-15 2.5q-8 0-15-2.5t-13-8.5L188-452q-11-11-11-27.5t11-28.5q12-12 28.5-12t28.5 12l195 195Z"
    ]
  }
} as const;
export function ArrowDownwardIcon(props: MaterialIconProps) { return <MaterialSymbol {...props} symbol="arrow_downward" artwork={artwork} />; }
